import React, { useEffect, useRef, useState } from "react";
import { AutoCompleteLocation } from "./useMapAutoComplete";
import * as uuid from "uuid";
import styled from "styled-components";
import SuggestionListItem from "./SuggestionListItem";
type SuggestionsListProps = {
  onClick: (item: AutoCompleteLocation) => void;
  onClose: () => void;
  suggestions: AutoCompleteLocation[];
};

/**
 * This Hook can be used for detecting clicks outside the Opened dropdown
 */
const useClickOutside = (ref: React.MutableRefObject<HTMLElement | null>, onClickOutside: () => void) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
};
function SuggestionsList(props: SuggestionsListProps) {
  const suggestionsRef = useRef<HTMLUListElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const {
    suggestions,
    onClick,
    onClose
  } = props;
  useEffect(() => {
    setIsOpen(true);
  }, [suggestions]);
  useClickOutside(suggestionsRef, () => {
    setIsOpen(false);
    onClose();
  });
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isOpen && suggestions.length > 0 && <List ref={suggestionsRef} id="autocomplete_list">
          {suggestions.map(line => <SuggestionListItem key={uuid.v4()} item={line} onClick={onClick} />)}
        </List>}
    </>
  );
}
const List = styled.ul`
  background: ${({
  theme
}) => theme.brand.cssVars["--d-card"]};
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 10;
  width: 100%;
  overflow-y: auto;
  border: 1px solid ${({
  theme
}) => theme.brand.cssVars["--d-border"]};
`;
export default SuggestionsList;